import {customerService} from '../../_services'

export default {
  state: {
    customers: [],
    maxCustomers: 10
  },
  mutations: {
    setCustomers (state, payload) {
      state.customers = payload
    },
    setEditedCustomer (state, payload) {
      var foundIndex = state.customers.findIndex(customer => customer.id === payload.id)
      if (foundIndex > -1) state.customers.splice(foundIndex, 1, payload)
    },
    addCustomer (state, payload) {
      if (state.customers.length === state.maxCustomers) {
        state.customers.push(payload)
        state.maxCustomers += 1
      }
    },
    addCustomers (state, payload) {
      if (state.customers.length <= (state.maxCustomers - payload.length)) {
        state.customers = state.customers.concat(payload)
      }
    },
    setMaxCustomers (state, payload) {
      state.maxCustomers = payload
    },
    removeCustomer (state, payload) {
      var foundIndex = state.customers.findIndex(customer => customer.id === payload)
      if (foundIndex > -1) {
        state.customers.splice(foundIndex, 1)
        state.maxCustomers -= 1
      }
    }
  },
  actions: {
    loadCustomers ({dispatch, commit}, filter) {
      dispatch('startDataLoading')
      customerService.searchCustomers(filter.searchTerms, filter.page, filter.size)
        .then(response => {
          commit('setMaxCustomers', response.data.totalElements)
          commit('addCustomers', response.data.content)
        })
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    resetCustomers ({commit}) {
      commit('setCustomers', [])
      commit('setMaxCustomers', 10)
    },
    addCustomer ({dispatch, commit}, customer) {
      dispatch('startLoading')
      customerService.createCustomer(customer)
        .then(response => {
          commit('addCustomer', response.data)
        })
        .then(() => dispatch('showNotification', {
          title: 'Kunde erfolgreich angelegt.',
          type: 'primary'
        }))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopLoading'))
    },
    editCustomer ({dispatch, commit}, customer) {
      dispatch('startLoading')
      customerService.updateCustomer(customer)
        .then(response => {
          commit('setEditedCustomer', response.data)
        })
        .then(() => dispatch('showNotification', {
          title: 'Kunde erfolgreich geändert.',
          type: 'primary'
        }))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopLoading'))
    },
    removeCustomer ({dispatch, commit}, customerId) {
      dispatch('startLoading')
      customerService.deleteCustomer(customerId)
        .then(response => {
          commit('removeCustomer', customerId)
        })
        .then(() => dispatch('showNotification', {
          title: 'Kunde erfolgreich gelöscht.',
          type: 'primary'
        }))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopLoading'))
    }
  },
  getters: {
    customers (state) {
      return state.customers
    },
    maxCustomers (state) {
      return state.maxCustomers
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/customer/index.js